import {useMutation} from '@tanstack/react-query';
export function useLogout() {
 return useMutation({mutationFn: async () => {
  const token=document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  const xsrf=document.cookie.split('; ').find(v=>v.startsWith('XSRF-TOKEN='))?.slice(11);
  const headers: Record<string,string>={'X-Inertia':'true','Accept':'application/json','X-Requested-With':'XMLHttpRequest'};
  if(token)headers['X-CSRF-TOKEN']=token;
  else if(xsrf)headers['X-XSRF-TOKEN']=decodeURIComponent(xsrf);
  else throw new Error('페이지를 새로고침한 뒤 다시 로그아웃해 주세요.');
  const r=await fetch('/auth/logout',{method:'POST',credentials:'same-origin',headers,redirect:'error'});
  const destination=r.headers.get('X-Inertia-Location');
  if(r.status!==409||!destination)throw new Error('로그아웃 요청을 확인할 수 없습니다. 페이지를 새로고침해 주세요.');
  window.location.assign(destination);
 }});
}
